import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Switch, Route, Redirect,withRouter,Lifecycle  } from "react-router-dom";
// import { Provider } from 'react-redux'
// import store from './redux/index'
import './js/rem.js';
import './style/common.css';
import Index from './pages/index/index'
import Info from './pages/info/index'
import InfoDetail from './pages/info/detail'
import Match from './pages/match/index'
import MatchStar from './pages/match/star'
import Interview from './pages/interview/index'
import VideoPlay from './pages/video-play/index'
import Culture from './pages/culture/index'
import CultureDetail from './pages/culture/detail'
import Train from './pages/train/index'
import TrainVenue from './pages/train/venue'
import TrainDeatil from './pages/train/detail'
import TrainClass from './pages/train/class'
import Equipment from './pages/equipment/index'
import EquipmentDetail from './pages/equipment/e_detail'
import EquipmentDetailE from './pages/equipment/detail'
import About from './pages/about/index'
import Layout from './pages/layout/index'
import PageContainer from './components/container/index'

ReactDOM.render(
    <HashRouter>
        {/* <Provider store = {store}> */}
        <PageContainer>
            <Layout>
                <Switch>
                        <Route path="/index" component={Index} exact/>
                        <Route path="/info" component={Info} exact/>
                        <Route path="/info/:id" component={InfoDetail} exact/>
                        <Route path="/match" component={Match} exact/>
                        <Route path="/match/:id" component={MatchStar} exact/>
                        <Route path="/interview/:id" component={Interview} exact/>
                        <Route path="/video/:id/:type" component={VideoPlay} exact/>
                        <Route path="/culture" component={Culture} exact/>
                        <Route path="/culture/:id" component={CultureDetail} exact/>
                        <Route path="/train" component={Train} exact/>
                        <Route path="/train/:id" component={TrainDeatil} exact/>
                        <Route path="/train/venue/:id" component={TrainVenue} exact/>
                        <Route path="/train/class/:id" component={TrainClass} exact/>
                        <Route path="/equipment" component={Equipment} exact/>
                        <Route path="/equipment/:id" component={EquipmentDetail} exact/>
                        <Route path="/equipment/detail/:id" component={EquipmentDetailE} exact/>
                        <Route path="/about" component={About} exact/>
                        <Redirect to="/index" />
                </Switch>
            </Layout>
        </PageContainer>
        {/* </Provider> */}
    </HashRouter>
    , document.getElementById('root'));

